import {Injectable} from "@angular/core";
import {AbstractControl, FormControl, FormGroup, ValidatorFn, Validators} from "@angular/forms";
import intlTelInput from "intl-tel-input";
import {Ng2ImgMaxService} from "ng2-img-max";
import {BehaviorSubject, Observable} from "rxjs";
import {FavoriteCardsService} from "../service/favorite-cards.service";
import {HASHTAGS_MAX_LENGTH} from "../constants/validation.constants";

@Injectable({
  providedIn: 'root',
})
export class UserCardUtil {
  iti: intlTelInput.Options | any;
  private _characterCountSubject = new BehaviorSubject<number>(0);
  characterCount$ = this._characterCountSubject.asObservable();
  maxLengthBio: number = 400
  maxLengthCommon: number = 60
  maxLengthNameSurname: number = 50
  minLengthNameSurname: number = 2

  constructor(
    private ng2ImgMax: Ng2ImgMaxService,
    private favoriteCardsService: FavoriteCardsService
  ) {
  }

  initializeForm(user?: any): FormGroup {
    return new FormGroup({
      name: new FormControl(user?.name, [Validators.required, Validators.minLength(this.minLengthNameSurname), Validators.maxLength(this.maxLengthNameSurname), this.whitespaceValidator()]),
      surname: new FormControl(user?.surname, [Validators.required, Validators.minLength(this.minLengthNameSurname), Validators.maxLength(this.maxLengthNameSurname), this.whitespaceValidator()]),
      about: new FormControl('', [Validators.maxLength(this.maxLengthBio), this.whitespaceValidator()]),
      specialization: new FormControl('', [Validators.maxLength(this.maxLengthCommon), this.whitespaceValidator()]),
      company: new FormControl('', [Validators.maxLength(this.maxLengthCommon), this.whitespaceValidator()]),
      location: new FormControl('', [Validators.maxLength(this.maxLengthCommon), this.whitespaceValidator()]),
      hashtagList: new FormControl([], [Validators.maxLength(HASHTAGS_MAX_LENGTH)])
    }, {updateOn: 'blur'});
  }

  whitespaceValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const value: string = control.value;
      if (value !== null && value.trim().length === 0 && value !== '') {
        return {whitespace: true};
      }
      return null;
    };
  }

  getFieldsLengthLimit() {
    return {
      maxLengthNameSurname: this.maxLengthNameSurname,
      minLengthNameSurname: this.minLengthNameSurname,
      maxLengthBio: this.maxLengthBio,
      maxLengthCommon: this.maxLengthCommon
    };
  }

  updateCharacterCounter(event: any){
    const target = event.target as HTMLTextAreaElement;
    this._characterCountSubject.next(target.value.length);
  }

  getNameSurnameLengthErrorMessage() {
    return 'Should be between ' + this.minLengthNameSurname + ' and ' + this.maxLengthNameSurname + ' characters long';
  }

  getCommonFieldsLengthErrorMessage(maxLength: number ) {
    return 'Should not exceed ' + maxLength + ' characters';
  }

  toggleFavorite(cardId: bigint, event: any, isFavoriteMap: { [key: string]: boolean }) {
    event.stopPropagation();
    if (isFavoriteMap[cardId.toString()]) {
      this.favoriteCardsService.deleteFavoriteCardByCurrentUserIdAndCardId(cardId).subscribe(() => {
        isFavoriteMap[cardId.toString()] = false;
      });
    } else {
      this.favoriteCardsService.saveFavoriteCardByCardId(cardId).subscribe(() => {
        isFavoriteMap[cardId.toString()] = true;
      });
    }
  }

  onEnter(event: any) {
    event.preventDefault();
  }

  initializeIntlTelInput(phoneInput: HTMLInputElement, countryIso: string): intlTelInput.Plugin {
    this.iti = intlTelInput(phoneInput, {
      initialCountry: countryIso,
      autoPlaceholder: 'polite',
      separateDialCode: true,
      utilsScript: 'node_modules/intl-tel-input/build/js/utils.js',
    } as intlTelInput.Options);

    return this.iti;
  }

  resizeImage(file: File, width: number, height: number): Observable<any> {
    return this.ng2ImgMax.resizeImage(file, width, height);
  }

}
